import { render, staticRenderFns } from "./tag-list.vue?vue&type=template&id=035d9bf9&scoped=true&"
import script from "./tag-list.vue?vue&type=script&lang=js&"
export * from "./tag-list.vue?vue&type=script&lang=js&"
import style0 from "./tag-list.vue?vue&type=style&index=0&id=035d9bf9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035d9bf9",
  null
  
)

export default component.exports